/* eslint-disable */

import { useState } from "react";

import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropMotionFadeUp from "../raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

const KindnessOption = ({
  kindnessAmount = null,
  newKindnessAmount = null,
  setNewKindnessAmount = (x) => {},
  initialSubunits = 0,
}) => {
  const initialKindnessValue = kindnessAmount || initialSubunits;
  const [subunits] = useState(initialKindnessValue);

  const isSelected = newKindnessAmount === subunits;

  const onClick = () => {
    setNewKindnessAmount(subunits);
  };

  const displayAmount = subunits / 100;

  return (
    <RaindropClickable onClick={onClick}>
      <RaindropCard isSelected={isSelected}>
        <div className="flex flex-col items-center justify-center w-[150px] h-[100px]">
          <div className="flex flex-row h-full items-center justify-center text-color-text-primary dark:text-color-dark-text-primary ">
            <h1 className="font-semibold text-xl ">£</h1>
            <h1 className="font-bold text-4xl">{displayAmount}</h1>
            {/* <RaindropTextSubtitle isCentered={true}>GBP</RaindropTextSubtitle> */}
          </div>
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

const ContentSelectPaymentAmount = ({
  newKindnessAmount,
  setNewKindnessAmount,
  doIncludeZero = false,
}) => {
  let kindnessOptions = doIncludeZero
    ? [
        {
          initialSubunits: 0,
          currency: "GBP",
        },
      ]
    : [];
  kindnessOptions = [
    ...kindnessOptions,
    {
      initialSubunits: 10_00,
      currency: "GBP",
    },
    {
      initialSubunits: 30_00,
      currency: "GBP",
    },
    {
      initialSubunits: 60_00,
      currency: "GBP",
    },

    {
      initialSubunits: 100_00,
      currency: "GBP",
    },
    {
      initialSubunits: 150_00,
      currency: "GBP",
    },
    {
      initialSubunits: 200_00,
      currency: "GBP",
    },
  ];

  return (
    <div className="flex flex-row flex-wrap gap-2 w-full  items-center justify-center">
      {kindnessOptions.map((kindnessOption, index) => (
        <RaindropMotionFadeUp delay={index * 0.1} key={index} className="w-min">
          <KindnessOption
            key={kindnessOption.initialSubunits}
            newKindnessAmount={newKindnessAmount}
            setNewKindnessAmount={setNewKindnessAmount}
            initialSubunits={kindnessOption.initialSubunits}
          />
        </RaindropMotionFadeUp>
      ))}
    </div>
  );
};

export default ContentSelectPaymentAmount;
